import { useState } from 'react';
import LoginForm from './login-form';
import ForgotPassword from './modal/ForgotPasswordModal';
import LayoutLogin from './layout/LayoutLogin';

const Login = () => {
    const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);

    const onShowHideForgotPassword = () => {
        setShowForgotPasswordModal(prev => !prev);
    };

    return (
        <LayoutLogin>
            <div className='flex flex-col items-center justify-center'>
                <h1 className='font-inter font-bold text-4xl text-center'>
                    Log in
                </h1>
                <p className='font-normal text-sm text-center mb-3'>
                    Into Account Management Dashboard
                </p>

                <LoginForm onShowHideForgotPassword={onShowHideForgotPassword} />

                <ForgotPassword
                    openForgotModal={showForgotPasswordModal}
                    handleCloseForgotModal={onShowHideForgotPassword}
                />
            </div>
        </LayoutLogin>
    );
};

export default Login;
